import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import moment from "moment";
import About from "../../../../../components/profile/About/index";
import Contact from "../../../../../components/profile/Contact/index";
import ProfileHeader from "../../../../../components/profile/ProfileHeader/index";
import Auxiliary from "../../../../../util/Auxiliary";
import maleAvatar from '../../../../../assets/images/icons/male-avatar.svg'
import femaleAvatar from '../../../../../assets/images/icons/female-avatar.svg'
import stancebeamIcon from '../../../../../assets/images/icons/stancebeam-icon.svg'

class Profile extends React.Component {
    constructor() {
        super()
        this.state = {
            aboutList: [
                {
                    id: 1,
                    title: 'Birthday',
                    icon: 'birthday',
                    desc: ''
                },
                {
                    id: 2,
                    title: 'Gender',
                    icon: 'gender',
                    desc: ''
                },
                {
                    id: 3,
                    title: 'Height (cms)',
                    icon: 'height',
                    desc: ''
                },
                {
                    id: 4,
                    title: 'Weight (kgs)',
                    icon: 'weight',
                    desc: ''
                },
                {
                    id: 5,
                    title: 'Batting Style',
                    icon: 'batting-style',
                    desc: ''
                },
                {
                    id: 6,
                    title: 'Grip Style',
                    icon: 'grip-style',
                    desc: ''
                }
            ],
            contactList: [
                {
                    id: 1,
                    title: 'Email',
                    icon: 'email',
                    desc: ''
                },
                {
                    id: 2,
                    title: 'Phone',
                    icon: 'phone',
                    desc: ''
                }
            ]
        }

    }

    componentDidMount() {
        if (this.props.playerInView !== null) {
            if (this.props.playerInView.hasOwnProperty("playerInfo")) {
                this.setState({
                    aboutList: [
                        {
                            id: 1,
                            title: 'Birthday',
                            icon: 'birthday',
                            desc: this.props.playerInView.playerInfo.dateOfBirthTs ? moment(this.props.playerInView.playerInfo.dateOfBirthTs).format('MMMM Do YYYY') : ""
                        },
                        {
                            id: 2,
                            title: 'Gender',
                            icon: 'gender',
                            desc: (this.props.playerInView.playerInfo.gender !== undefined && this.props.playerInView.playerInfo.gender !== "null") ? this.props.playerInView.playerInfo.gender : "male"
                        },
                        {
                            id: 3,
                            title: 'Height (cms)',
                            icon: 'height',
                            desc: this.props.playerInView.playerInfo.height ? Math.round(this.props.playerInView.playerInfo.height) : ""
                        },
                        {
                            id: 4,
                            title: 'Weight (kgs)',
                            icon: 'weight',
                            desc: this.props.playerInView.playerInfo.weight ? Math.round(this.props.playerInView.playerInfo.weight) : ""
                        },
                        {
                            id: 5,
                            title: 'Batting Style',
                            icon: 'batting-style',
                            desc: this.props.playerInView.playerInfo.isRightHand ? (this.props.playerInView.playerInfo.isRightHand ? "Right handed" : "Left handed") : "Right handed"
                        },
                        {
                            id: 6,
                            title: 'Grip Style',
                            icon: 'grip-style',
                            desc: this.props.playerInView.playerInfo.gripPosition ? this.props.playerInView.playerInfo.gripPosition : "medium"
                        }
                    ],
                    contactList: [
                        {
                            id: 1,
                            title: 'Email',
                            icon: 'email',
                            desc: [<span className="jr-link" key={1}>{this.props.playerInView.playerInfo.emailId}</span>]
                        },
                        {
                            id: 2,
                            title: 'Phone',
                            icon: 'phone',
                            desc: this.props.playerInView.phone ? this.props.playerInView.playerInfo.phone : ""
                        }
                    ]
                })
            } else {
                this.setState({
                    contactList: [
                        {
                            id: 1,
                            title: 'Email',
                            icon: 'email',
                            desc: [<span className="jr-link" key={1}>{this.props.playerInView.email}</span>]
                        },
                        {
                            id: 2,
                            title: 'Phone',
                            icon: 'phone',
                            desc: this.props.playerInView.phone ? this.props.playerInView.phone : ""
                        }
                    ]
                })
            }
        } else {
            this.props.history.push('/app/players')
        }
    }

    render() {
        const fullName = this.props.playerInView !== null ? this.props.playerInView.fullName : ""
        const city = this.props.playerInView !== null ? (this.props.playerInView.hasOwnProperty("playerInfo") ? (this.props.playerInView.playerInfo.hasOwnProperty("city") ? (this.props.playerInView.playerInfo.city !== "null" ? this.props.playerInView.playerInfo.city : "") : "") : "") : ""
        const country = this.props.playerInView !== null ? (this.props.playerInView.hasOwnProperty("playerInfo") ? (this.props.playerInView.playerInfo.hasOwnProperty("country") ? (this.props.playerInView.playerInfo.country !== "null" ? this.props.playerInView.playerInfo.country : "") : "") : "") : ""
        const avatarIcon = this.props.playerInView !== null ? (this.props.playerInView.hasOwnProperty("playerInfo") ? (this.props.playerInView.playerInfo.hasOwnProperty("gender") ? (this.props.playerInView.playerInfo.gender === "female" ? femaleAvatar : maleAvatar) : stancebeamIcon) : stancebeamIcon) : stancebeamIcon
        const profileImage = this.props.playerInView !== null ? (this.props.playerInView.hasOwnProperty("playerInfo") ? (this.props.playerInView.playerInfo.hasOwnProperty("profilePic") ? this.props.playerInView.playerInfo.profilePic : avatarIcon) : avatarIcon) : avatarIcon
        var loc = ""
        if (city === "") {
            loc = country
        } else {
            loc = city + ", " + country
        }
        return (
            <Auxiliary>
                <ProfileHeader history={this.props.history} name={fullName} location={loc} profilePic={profileImage} />
                <div className="jr-profile-content">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-7 col-12">
                            <About aboutList={this.state.aboutList} />
                            {/* <Biography bio={this.state.player.biography ? this.state.player.biography : ""} /> */}
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-5 col-12">
                            <Contact contactList={this.state.contactList} />
                            {/* <div className="row">
                                <div className="col-12">
                                    <div className="jr-card">
                                    </div>
                                </div>
                                <div className="col-12">
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

const mapStateToProps = ({ settings, player }) => {
    const { playerInView } = player;
    const { width, drawerType, navigationStyle, horizontalNavPosition } = settings;
    return { playerInView, width, drawerType, navigationStyle, horizontalNavPosition }
};
export default withRouter(connect(mapStateToProps)(Profile));